var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 36.41a36 36 0 1 1 72 0 36 36 0 0 1-72 0m26.48-15.314a3.37 3.37 0 0 0-1.73 2.939v24.75c0 1.223.66 2.348 1.73 2.939a3.38 3.38 0 0 0 3.417-.07l20.25-12.376a3.39 3.39 0 0 0 1.617-2.882 3.39 3.39 0 0 0-1.617-2.883l-20.25-12.375a3.41 3.41 0 0 0-3.417-.07z"
  })));
};
export default SvgPlay;